import donateCommonAppFeesMixin from '@/mixins/donations/donateCommonAppFeesMixin.js'

export default {
  mixins:[donateCommonAppFeesMixin],
  data() {
    return {
      ValidationErrorMessage: null,
      Donation: null,
      DonationName: null,
      DonationAmount: 50,
      DonationAppFeeAmount: 2,
      DonationGatewayActive: false,
      DonationCompleted: false,
      DonationAnonymousName: false,
      DonationAnonymousAmount: false,
      DonationShowCommentForm: false,
      DonationComment: null,
      DonationFundraiserChild: null,
      StripeCheckoutObject: null
    }
  },
  watch: {
    DonationAmount(newVal) {
      this.DonationAppFeeAmount = this.donationAppFeeAmountProposed(newVal)
    }
  },
  computed: {
    donationTotalAmount() {
      if(!this.DonationAmount) return 0
      return parseInt(this.DonationAmount) + this.DonationAppFeeAmount
    },
    donateButtonDisabled() {
      return this.DonationGatewayActive || this.DonationCompleted || !this.DonationAmount || !this.DonationName
    }
  }
}
